import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CtaBlock } from './CtaBlock';
import { includes } from '../data/content';
const flow = ['Domanda', 'Protocollo', 'Decisione', 'Follow-up'];
export function Includes() {
  return <section className="bg-white py-14 sm:py-20" data-id="element-226" data-mp="3k83di3p13ape">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6" data-id="element-227" data-mp="3k9y0ronrvewn">
        <SectionHeading eyebrow="Perché questa risorsa" title="Il problema non è che le informazioni non esistano. È che sono sparse." subtitle="Una linea guida dice una cosa. Uno studio aggiunge contesto. Un risultato di laboratorio genera un’altra domanda. E una decisione che dovrebbe essere organizzata diventa un’altra sessione di ricerca." data-id="element-228" data-mp="3p8989sqlhdbp" />

        <div className="mt-10 grid gap-3 sm:grid-cols-2" data-id="element-229" data-mp="23umx2dvhehia">
          {includes.map(item => <div key={item.title} className="flex gap-3 rounded-xl border border-navy-900/10 bg-navy-50/60 p-4" data-id="element-230" data-mp="28sya0xh2p84q">
              <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-gold-600" aria-hidden="true" data-id="element-231" data-mp="3ugpg2e1szr76" />
              <div data-id="element-232" data-mp="3lmkuoa5fv7z1">
                <h3 className="text-[14px] font-black uppercase tracking-tight text-navy-900" data-id="element-233" data-mp="3lo5n9u870gu9">
                  {item.title}
                </h3>
                <p className="mt-1 text-[13px] leading-relaxed text-navy-900/70" data-id="element-234" data-mp="3gm6komka1nyd">
                  {item.text}
                </p>
              </div>
            </div>)}
        </div>

        <div className="mt-10 rounded-2xl border border-navy-900/10 bg-navy-900 p-6 sm:p-8" data-id="element-235" data-mp="d56ks90j4jlp">
          <p className="text-center text-[15px] font-black uppercase leading-snug tracking-tight text-white sm:text-xl" data-id="element-236" data-mp="8aanatcix417">
            Progettato come un riferimento pratico
          </p>
          <ol className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-4" data-id="element-237" data-mp="2szqbdgkcyen5">
            {flow.map((step, i) => <li key={step} className="rounded-xl border border-white/10 bg-white/[0.05] px-3 py-4 text-center" data-id="element-238" data-mp="2o1f0d2ibty3c" data-mpi={i}>
                <span className="block text-[10px] font-black uppercase tracking-[0.18em] text-gold-400" data-id="element-239" data-mp="2uejaenxx0ave">
                  0{i + 1}
                </span>
                <span className="mt-1.5 block text-[13px] font-extrabold uppercase tracking-tight text-white sm:text-sm" data-id="element-240" data-mp="2lew71wlmkuzp">
                  {step}
                </span>
              </li>)}
          </ol>
        </div>

        <div className="mt-10 flex justify-center" data-id="element-241" data-mp="2bgzwp70ii42n">
          <CtaBlock label="Accedi al sistema completo per 19 EUR" note="Pagamento unico · Accesso a vita" data-id="element-242" data-mp="2bit62u2if2ec" />
        </div>
      </div>
    </section>;
}